import { fromJS, List, Map } from "immutable";
// How many events do we want to show in the slider? We can change this based on media match later
export const POPULAR_SEARCH_RESULTS_COUNT = 5;
export const RECENT_SEARCH_RESULTS_COUNT = 5;
// no of cards to show in venues carousel
export const VENUES_CAROUSEL_MAX_CARDS = 8;
// set the default value based on window.env so that client side rendering is taken care of
// window.env variable is passed to article.hbs though article route
export let API_URL = typeof window !== "undefined" && window.env === "live" ? "https://api.insider.in" : "https://api-staging.insider.in";
export let SENDBIRD_APP_ID = typeof window !== "undefined" && window.env === "live"
    ? "317D21BE-7263-4E62-B537-00C74F3D4186"
    : "13ADE433-D850-4E7C-896A-68E95269B25B";
const ChromeCastReceiverIdLive = "6FEE197F";
const ChromeCastReceiverIdNew = "73CB60D1";
export const getChromeCastAppID = () => typeof window !== "undefined" && window.location.host === "insider.in"
    ? ChromeCastReceiverIdLive
    : ChromeCastReceiverIdNew;
// below function sets apiurl for server side, based on node env variable being passed
export const setApiUrl = env => {
    API_URL = env === "live" ? (API_URL = "https://api.insider.in") : "https://api-staging.insider.in";
};
// payment url
export let PAYMENT_URL = typeof window !== "undefined" && window.env === "live"
    ? "https://payment.insider.in"
    : "https://payment-staging.insider.in";
export const supportedNativePGs = ["stripe"];
// Image constants
export const CLOUDINARY_URL = "https://res.cloudinary.com";
export const CLOUDINARY_CLOUD_NAME = "dwzmsvp7f";
export const CLOUDINARY_IMAGE_URL = `${CLOUDINARY_URL}/${CLOUDINARY_CLOUD_NAME}/image`;
export const CLOUDINARY_FETCH_IMAGE_URL = `${CLOUDINARY_IMAGE_URL}/upload`;
export const CLOUDINARY_FETCH_IMAGE_URL_OLD = `${CLOUDINARY_IMAGE_URL}/fetch`;
export const CLOUDINARY_YOUTUBE_THUMBNAIL_URL = `${CLOUDINARY_IMAGE_URL}/youtube`;
export const CLOUDINARY_DEFAULT_OPTIONS = {
    f: "auto" // format
};
export const PLAY_ICON = "YouTube-icon-full_pm9f2l.png";
// Algolia constants
export const ALGOLIA_APP_ID = "1BFWMGCHJ2";
export const ALGOLIA_SEARCH_API_KEY = "d96f92a248e8dd9aa36d08c78678a956";
export const ALGOLIA_INDICES = [
    { name: "events", displayTitle: "Events" },
    { name: "articles", displayTitle: "Articles" },
    { name: "artists", displayTitle: "Artists" },
    { name: "venues", displayTitle: "Venues" }
];
//staging
//export const ALGOLIA_APP_ID = 'X4FS5MAZ47';
//export const ALGOLIA_SEARCH_API_KEY = 'c1a1e182a3c5908f725a4d3c7a3b7f57';
// Social constants
export const FB_APP_ID = "814871095224869";
export const MAPS_ID = "AIzaSyBsLPaH_rghM0JWluvD7WqKczfDEA8Q7Zo";
//export const MAPS_ID = 'AIzaSyA5qAhplbhYhQ1pYEU50cGoGsdWnU0HFvw'; // For localhost
// Style constants
export const NO_DATA_CLASS = "no-data";
// Tag constants
export const GO_OUT_TAG_ID = "57d2ae0c9cbfe04307423136";
export const STAY_IN_TAG_ID = "57d2afcf02b779430717bf4d";
export const MINIMUM_PASSWORD_LENGTH = 6;
// TODO move this to helmet functions
export const SECTION_TITLE = {
    "go-out": (city = "India") => `The Best Events, Travel and Food in ${capitalizeFirstLetter(city)}`,
    "stay-in": () => `Trending on the internet`
};
export const DEFAULT_CATEGORY_LOGO = "https://media.insider.in/image/upload/c_crop,g_custom/v1491828643/tiyivzyhhnl7fo7qcfh2.jpg";
// Clevertap and GA Event Related Constants
export const GENERAL_ACTIONS = {
    CLICK: "click",
    CLOSE: "close",
    FAVOURITE: "favourite",
    LOGIN: "login",
    OPEN: "open",
    SEND: "send",
    UNFAVOURITE: "unfavourite"
};
export const GA_ACTIONS = {
    FAVOURITE_BUTTON_LOGIN_CLICK: "ClickFavouriteButtonLogin",
    FAVOURITE_EVENT: "ClickFavourite",
    FAVOURITES_LIST_CLICK: "ClickFavouritesList",
    FAVOURITES_LIST_LOGIN_CLICK: "ClickFavouritesListLogin",
    GENRE_FILTER: "Genre",
    CITY_FILTER: "City",
    SORT_FILTER: "Sort",
    TYPE_FILTER: "Type",
    TIME_FILTER: "Time",
    TRENDING_EVENTS: "Trending Events",
    UNFAVOURITE_EVENT: "ClickUnfavourite",
    WEB_FILTER_CLICKED: "ClickWebFilter",
    CONTINUE: "Continue"
};
const DEFERRED_CHECKOUT_ACTIONS = {
    DEFERRED_CHECKOUT_BRIDGE_ERROR: "Deferred Checkout Bridge Error",
    DEFERRED_CHECKOUT_BRIDGE_SUCCESS: "Deferred Checkout Bridge Success"
};
const BANK_OFFERS_ACTIONS = {
    BANK_OFFERS: "Bank Offers",
    BANK_OFFERS_APPLIED_SUCCESSFULLY: "Bank Offers Applied Successfully",
    BANK_OFFERS_ERROR_OCCURED: "Bank Offers Error Occured",
    BANK_OFFERS_REMOVED_SUCCESSFULLY: "Bank Offers Removed Successfully",
    BANK_OFFERS_REMOVE_ERROR_OCCURED: "Bank Offers Remove Error Occured",
    SHOW_PREPAYMENT_BRIDGE_ERROR: "Show Prepayment Bridge Error",
    SHOW_PREPAYMENT_BRIDGE_SUCCESS: "Show Prepayment Bridge Success",
    DISCOUNT_CODE_TYPED_APPLIED_SUCCESSFULLY: "Discount Code Typed Applied Successfully",
    DISCOUNT_CODE_TYPED_ERROR_OCCURED: "Discount Code Typed Error Occured",
    DISCOUNT_CODE_TYPED_REMOVED_SUCCESSFULLY: "Discount Code Typed Removed Successfully",
    DISCOUNT_CODE_TYPED_REMOVE_ERROR_OCCURED: "Discount Code Typed Remove Error Occured"
};
const BUY_FLOW_CLEVERTAP_ACTIONS = {
    BUY_PAGE_FIRST_LOAD: "Buy | Buy Page First Load",
    SVG_FILTER_APPLIED: "Buy | SVG Filter Applied",
    SVG_SECTION_CLICKED: "Buy | SVG Section Clicked",
    INFO_ICON_CLICKED_FOR_SEATED: "Buy | Info Icon Clicked For Seated",
    ADD_TO_CART_CLICKED: "Buy | Add To Cart Clicked",
    ADD_TO_CART_CLICKED_FOR_ADDONS: "Buy | Add To Cart Clicked For Addons",
    ERROR_MODAL_OPENED: "Buy | Error Modal Opened",
    ADDONS_PAGE_OPENED: "Buy | Addons Page Opened",
    ADDONS_SKIPPED: "Buy | Addons Skipped",
    BUY_MORE_TICKETS_CLICKED: "Checkout | Buy More Tickets Clicked",
    BUY_MORE_ADDONS_CLICKED: "Checkout | Buy More Addons Clicked",
    UPDATE_CART_CLICKED: "Buy | Update Cart Clicked",
    UPDATE_CART_CLICKED_FOR_ADDONS: "Buy | Update Cart Clicked For Addons",
    DISCOUNT_CODE_APPLIED: "Checkout | Discount Code Applied",
    ORDER_SUMMARY_PAGE_VIEWED: "Checkout | Order Summary Page Viewed",
    TICKET_DELIVERY_OPTION_SELECTED: "Checkout | Ticket Delivery Option Selected",
    ITEMS_DELETED_FROM_ORDER_SUMMARY: "Checkout | Items Deleted From Order Summary",
    TAX_BREAKDOWN_CLICKED: "Checkout | Tax Breakdown Clicked",
    PINCODE_ELIIGIBILITY_CHECKED: "Checkout | Pincode Eligibility Checked",
    CHECKOUT_ERROR: "Checkout | Checkout Error",
    CLEAR_CART_CLICKED: "Buy | Clear Cart Clicked",
    VIEW_CART_CLICKED: "Buy | View Cart Clicked",
    VIEW_CART_CLICKED_FOR_ADDONS: "Buy | View Cart Clicked For Addons"
};
export const CLEVERTAP_ACTIONS = Object.assign(Object.assign(Object.assign(Object.assign({ AD_CLICK: "Ad Click", FAVOURITE_BUTTON_CLICK: "Favourite button clicked", FAVOURITES_LIST_ICON_CLICK: "Favourites list icon clicked", FAVOURITES_LOGIN_CLICK: "Favourite Login clicked", LIST_PAGE_VIEWED: "List page viewed", PRODUCT_VIEWED: "Product Viewed", RECENTLY_VIEWED_CLICK: "Recently viewed clicked", SEARCH_RESULT_CLICKED: "Search Result Clicked", WEB_FILTER_CLICKED: "Web Filter Clicked", WEB_SORTER_CLICKED: "Web Sorter Clicked", WEB_TO_APP_BANNER_CLICK: "Check web2app banner click", EDP_SHARE_PILL_FALLBACK: "Edp share pill fallback clicked", EDP_SHARE_PILL_CLICKED: "Edp share pill clicked", WEB_HOME_VISITED: "Web homepage visited", HOME_BANNER_CLICKED: "Banner Click", FEATURED_CAROUSEL_CLICKED: "Featured carousel", DAY_CAROUSEL: "Day Carousel", GENRE_CAROUSEL: "Genre carousel", POPULAR_CAROUSEL: "Popular carousel", ARTIST_CAROUSEL: "Artist carousel", VENUE_CAROUSEL: "Venue carousel", PAYMENT_SCREEN_LOADED: "Payment options loaded", PAYMENT_METHOD_SELECTED: "Payment method selected", PAYMENT_METHOD_PAY_NOW: "Native pay now", PAYMENT_METHOD_SAVE: "Native method saved", LIVE_EVENT_JOINED: "Live event joined", LIVE_EVENT_ENTERED_GAME: "Live event entered game", LIVE_EVENT_PLAYED: "Live event played", LIVE_EVENT_ENGAGEMENT_RECEIVED: "Live event engagement received", LIVE_EVENT_VIEWED_END_SCREEN: "Live event viewed end screen", LIVE_EVENT_DROPPED_OFF: "Live event dropped off", LIVE_EVENT_STREAMING_LATENCY: "Live event streaming latency", LIVE_EVENT_ANSWER_QUESTION: "Live event answered question", LIVE_EVENT_WINNINGS: "Live event winnings", LIVE_EVENT_CLICKED_GAME_PLAY_BUTTON: "Live event clicked game play button", LIVE_EVENT_CLICKED_LEDP_PLAY_BUTTON: "Live event clicked LEDP play button", LIVE_EVENT_ClICKED_DEEP_LINK: "Live event clicked deeplink", LIVE_EVENT_OPEN_PAYTM_LOGIN_MODAL: "Live event opened Paytm login modal", LIVE_EVENT_ESTABLISHED_VIDEO_CONNECTION: "Live event established video connection", LIVE_EVENT_PLAYER_CONNECTED: "Live event PlayerConnect successful", LIVE_EVENT_MQTT_OFFLINE: "Live event MQTT went offline", LIVE_EVENT_MQTT_CONNECTED: "Live event MQTT connected", LIVE_EVENT_FAILED_PLAYER_CONNECT: "Live event failed PlayerConnect", LIVE_EVENT_FOLLOWED_EVENT: "Live event followed event", LIVE_EVENT_UNFOLLOWED_EVENT: "Live event unfollowed event", LIVE_EVENT_VIDEO_PROGRESS: "Live event video progress", LIVE_EVENT_GAME_BACKGROUND: "Live event game sent to background", LIVE_EVENT_GAME_FOREGROUND: "Live event game brought to foreground", LIVE_EVENT_VIMEO_PLAYED_FIRST_TIME: "Live event vimeo played first time", LIVE_EVENT_SEND_COMMENT: "Live event send comment", EDP_COUPON_COPIED: "EDP Coupon Copied", H5_FORCE_UPDATE_DISPLAYED: "H5 force update displayed", H5_FORCE_UPDATE_ACTION: "H5 force update action", ADD_EVENT_REMINDER: "RemindmeNotification", CATEGORY_CAROUSEL: "Custom carousel", DIGITAL_EVENTS_GRID_CLICK: "2x3 Carousel Click", FAVOURITE_NOTIFICATION: "FavouriteNotification", HEADER_NAV_CLICK: "Clicked Header Link", VIDEO_CLICK: "Insider Video Click", CITY_SELECTION: "City Selection", CITY_SELECTION_OVERLAY: "City Selection Overlay", USE_CURRENT_LOCATION_SUCCESS: "Use Current Location Success", USE_CURRENT_LOCATION_ERROR: "Use Current Location Error", BUY_NOW_CTA_BUTTON: "Buy Now / CTA Button", CHECKOUT_TO_REACH_PAYMENTS_PAGE: "Checkout to payments page", LOGIN_OTP_SENT: "Login OTP Sent", INCORRECT_OTP_SUBMITTED: "Incorrect OTP Submitted", UPI_INTENT_SUCCESS: "UPI Intent Transaction Success", UPI_INTENT_FAILURE: "UPI Intent Transaction Failure", RETRY_UPI_INTENT: "Retry UPI Intent Transaction", PAYTM_WALLET_MONEY_ADDED: "Paytm Wallet Money Added", PAYTM_WALLET_ADD_MONEY_CANCELLED: "Paytm Wallet Add Money cancelled", PAYTM_WALLET_TXN_SUCCESS: "Paytm Wallet Transaction Success", PAYTM_WALLET_TXN_FAILURE: "Paytm Wallet Transaction Failure", INVALID_UPI_ID: "Invalid UPI ID", UPI_RATE_LIMIT_REACHED: "UPI Validation Rate Limit Reached", ONE_TAP_LOGIN_SUCCESS: "Google One Tap Login Success", UPI_NAVIGATE_FAILED: "Navigate to Intent Processing Page Failed", UPI_NAVIGATE_TIMED_OUT: "Navigate to Intent Processing Timed Out", RELATED_CAROUSEL: "Related Carousel", ADD_MORE_TO_CART: "Add More To Cart", PROMO_MAILS_UNSUBSCRIBED: "Promo Mails Unsubscribed", PROMO_MAILS_RESUBSCRIBED: "Promo Mails Resubscribed", CAROUSEL_VIEW_ALL_CLICKED: "Carousel View All Clicked", SPLIT_PAYMENTS_CLICKED: "Split Payments clicked", REDIRECTED_TO_H5_USING_INSIDER_LINK: "Redirected to H5 using Insider link", SEARCH_CLICKED: "Search Clicked", ISL_NOTIFY_ME_CLICK: "ISL Notify Me Clicked", ISL_NAV_LOGO_CLICKED: "ISL NAV Home Logo Clicked", ISL_NAV_HOME_CLICKED: "ISL NAV Home Clicked", ISL_NAV_SCHEDULE_CLICKED: "ISL NAV Schedule Clicked", ISL_NAV_STANDINGS_CLICKED: "ISL NAV Standings Clicked", ISL_FOOTER_KNOW_MORE_CLICKED: "ISL Footer Know More Clicked", ISL_LANDING_KNOW_MY_TEAM_CLICKED: "ISL Landing Know My Team Clicked", ISL_SCHEDULE_FILTER_BY_MATCHES: "ISL Schedule Filter By Matches", ISL_SCHEDULE_FILTER_BY_TEAM: "ISL Schedule Filter By Team", SEARCH_QUICK_FILTER_CLICKED: "Search Quick Filter", QUICK_LINK_CLICKED: "Quick link clicked", CATEGORY_HIGHLIGHT_CLICKED: "Category highlight clicked", NYE_CITY_CARD_CLICKED: "NYE City Card Clicked", NYE_CATEGORY_CARD_CLICKED: "NYE Category Card Clicked", SHOWCASE_CLICKED: "Showcase Clicked", CHARGED_V3: "ChargedV3", IPL_NOTIFY_ME_CLICK: "IPL Notify Me Clicked", IPL_NAV_LOGO_CLICKED: "IPL NAV Home Logo Clicked", IPL_NAV_HOME_CLICKED: "IPL NAV Home Clicked", IPL_NAV_SCHEDULE_CLICKED: "IPL NAV Schedule Clicked", IPL_NAV_STANDINGS_CLICKED: "IPL NAV Standings Clicked", IPL_FOOTER_KNOW_MORE_CLICKED: "IPL Footer Know More Clicked", IPL_LANDING_KNOW_MY_TEAM_CLICKED: "IPL Landing Know My Team Clicked", IPL_SCHEDULE_FILTER_BY_MATCHES: "IPL Schedule Filter By Matches", IPL_SCHEDULE_FILTER_BY_TEAM: "IPL Schedule Filter By Team", HOLI24_CITY_CARD_CLICKED: "HOLI24 City Card Clicked", HOLI24_CATEGORY_CARD_CLICKED: "HOLI24 Category Card Clicked", FOOTER_APP_STORE_DOWNLOAD_CLICKED: "Footer | App download CTA click", FOOTER_EDP_LINK_CLICKED: "Footer | EDP Link clicked" }, BUY_FLOW_CLEVERTAP_ACTIONS), BANK_OFFERS_ACTIONS), DEFERRED_CHECKOUT_ACTIONS), { EVENT_CARD_LIST_COMPONENT_CLICKED: "Event Card List Component Clicked" });
export const HIT_TYPES = {
    EVENT: "event"
};
export const EVENT_CATEGORIES = {
    FILTER: "Filter",
    SEARCH: "Search",
    SIDEBAR: "Sidebar",
    WE_ARE_HIRING: "WeAreHiring",
    PROMO_CODE: "Promo Code",
    ORDER_SUMMARY: "Order Summary",
    CITY_SEARCH: "City Search",
    CITY_SELECTOR: "City Selector",
    RECENTLY_VIEWED: "Recently Viewed",
    FEATURED_EVENTS: "Featured Events",
    HOMEPAGE_BANNER: "Homepage Banner",
    GENRE: "Genre",
    TD_CONTINUE: "TD Continue",
    SIGN_IN: "Sign In",
    SIGN_OUT: "Sign Out",
    HOMEPAGE_GROUP: "Homepage Group",
    SHARE: "Share",
    CITY: "City",
    LIST_EVENT_CLICK: "List your Event",
    EMAIL_LOGIN: "EmailLogin"
};
export const EVENT_ACTIONS = {
    CHECKOUT: "Checkout",
    CONTINUE: "Continue",
    NAME: "Name",
    SUCCESS: "Success",
    FAILURE: "Failure"
};
export const EVENT_LABELS = {};
export const EVENT_CONTEXTS = {
    HEADER: "header"
};
//Google Analytics 4 recommended events
export const GA_RECOMMENDED_EVENTS = {
    LOGIN: "login",
    SHARE: "share",
    SEARCH: "search",
    ADD_TO_CART: "add_to_cart",
    REMOVE_FROM_CART: "remove_from_cart",
    VIEW_CART: "view_cart",
    ADD_TO_WISHLIST: "add_to_wishlist",
    SELECT_CONTENT: "select_content",
    BEGIN_CHECKOUT: "begin_checkout",
    PURCHASE: "purchase",
    VIEW_ITEM: "view_item",
    ADD_SHIPPING_INFO: "add_shipping_info",
    SCREEN_VIEW: "screen_view"
};
export const GA_EVENT = "event";
/**
 * Truncate String
 * @param {string} str
 * @param {number} length
 * @param {string|null} ending
 * @returns {*}
 */
export const truncate = (str, length, ending) => {
    if (length === null) {
        length = 100;
    }
    if (ending === null) {
        ending = "...";
    }
    if (str && str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    }
    else {
        return str;
    }
};
/**
 * Capitalize
 * @param string
 * @returns {string}
 */
export const capitalizeFirstLetter = string => string && `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
/**
 * Our ${city} replacement regex defined once
 * @constant
 * @type {RegExp}
 */
const CITY_REGEX = /(\$\{city\})/gim;
export const TIME_FILTERS = [
    {
        display: "Today",
        key: "today"
    },
    {
        display: "Tomorrow",
        key: "tomorrow"
    },
    {
        display: "Weekend",
        key: "weekend"
    }
];
export const TIMES = TIME_FILTERS.map(time => time.key);
export const timeString = timeFilter => {
    if (timeFilter) {
        var timeFilterDisplayName = TIME_FILTERS.find(time => time.key === timeFilter).display.toLowerCase();
        // hack for interpolation this weekend since our hompage card for this timefilter change
        // to just weekend
        if (timeFilterDisplayName === "weekend") {
            return "This Weekend";
        }
        return timeFilterDisplayName.charAt(0).toUpperCase() + timeFilterDisplayName.slice(1);
    }
    return "";
};
/**
 * RegEx test https://regex101.com/r/TAzism/1
 * Replace all ${city} placeholder with the client selectedCity
 * @param {string} string
 * @param {string} city
 * @return {string} string
 */
export const replaceCityAndTimePlaceholder = (string, city, timeFilter, eventCount) => {
    eventCount = eventCount >= 10 ? String(eventCount) : "";
    if (string) {
        const TIME_REGEX = /(\${time})/gim;
        const COUNT_REGEX = /(\${count})/gim;
        return string
            .replace(CITY_REGEX, capitalizeFirstLetter(city))
            .replace(TIME_REGEX, timeString(timeFilter))
            .replace(COUNT_REGEX, eventCount)
            .replace(/ {2,}/g, " ") // remove double spaces
            .trim(); // remove trailing spaces
    }
    return string;
};
/**
 * Picks buy button text for a given event
 * @param {string} eventState
 * @param {string} actionText
 * @param {boolean} isRsvp
 * @return {{buyButtonState: boolean, buyButtonHelperText: string, buyButtonText: string, disabled: boolean}}
 */
export const getBuyButtonText = (eventState, actionText, isRsvp, communication_strategy) => {
    let buyButtonState = true;
    let buyButtonHelperText;
    let buyButtonText = "BUY";
    let disabled = false;
    if (eventState === "available" || !eventState) {
        buyButtonHelperText = "";
        buyButtonState = false;
        if (actionText) {
            buyButtonText = actionText;
        }
        else if (isRsvp) {
            buyButtonText = "RSVP";
        }
        else {
            buyButtonState = "BUY";
        }
    }
    if (eventState === "expired") {
        buyButtonHelperText = "Sorry, this show is already over but head <a href='/'>here</a> for other fun events!";
        buyButtonText = "Fin.";
        disabled = true;
    }
    if (eventState === "sold_out") {
        buyButtonHelperText = "Tickets are sold out for this show";
        buyButtonText = "SOLD OUT";
        disabled = true;
    }
    if (eventState === "tickets_at_venue") {
        buyButtonState = false;
        buyButtonHelperText = "Tickets are subject to availability";
        buyButtonText = "TICKETS AT VENUE";
        disabled = false;
    }
    if (eventState === "cancelled") {
        buyButtonHelperText = "";
        buyButtonText = "CANCELLED";
        disabled = true;
    }
    if (eventState === "rescheduled") {
        buyButtonHelperText = "Hey, this event has been rescheduled but watch this space for updates.";
        buyButtonText = "RESCHEDULED";
        disabled = true;
    }
    if (eventState === "unavailable") {
        buyButtonHelperText =
            "Sorry, this show is not available anymore but head <a href='/'>here</a> for other fun events!";
        buyButtonText = "UNAVAILABLE";
        disabled = true;
    }
    if (eventState === "coming_soon") {
        buyButtonHelperText = "Tickets will be available soon.";
        buyButtonText = "COMING SOON";
        disabled = true;
    }
    return {
        buyButtonState,
        buyButtonHelperText,
        buyButtonText,
        disabled
    };
};
/**
 * Picks display mode according to the
 * tagIds on an event/article
 * @param {Immutable.List<String>} tagIds
 * @return {string}
 */
export const chooseDisplayMode = tagIds => {
    // no tags have been set
    if (!tagIds || !tagIds.size) {
        return "homepage";
    }
    // first check for go out
    const goOutDisplayMode = tagIds.find(t => t.get("tag_id") === GO_OUT_TAG_ID);
    if (goOutDisplayMode) {
        return "go-out";
    }
    // phir stay in
    const stayInDisplayMode = tagIds.find(t => t.get("tag_id") === STAY_IN_TAG_ID);
    if (stayInDisplayMode) {
        return "stay-in";
    }
    // default
    return "homepage";
};
/**
 * Picks secure userinfo
 * @param {object} userInfo
 * @return {object}
 */
export const pickSecureUserInfo = userInfo => ({
    email: userInfo.email,
    first_name: userInfo.first_name,
    last_name: userInfo.last_name || "",
    handle: userInfo.handle
});
/**
 * If an event has expired, we need to ignore it's event_state
 * and show it as being expireed
 * @param {Immutable.Map} eventData
 * @return {string}
 */
export const getComputedState = eventData => {
    // if event state is something other then available return as is
    const currentEventState = eventData.get("event_state");
    if (currentEventState !== "available") {
        return currentEventState;
    }
    const showsForEvent = eventData.getIn(["venue", "shows"]);
    // if now shows were sent from core, it's expired
    if (!showsForEvent || !showsForEvent.size) {
        return "expired";
    }
    // there are shows
    // find the last show
    const lastEndTime = showsForEvent.map(s => s.get("end_utc_timestamp")).max();
    if (new Date() > new Date(lastEndTime * 1000)) {
        return "expired";
    }
    // checking if show is not sold out, not hidden, itemGroup is available and
    // item is not hidden, is available and has has purchase count
    const showInJs = showsForEvent.toJS();
    let isItemAvailable = false;
    if (showInJs) {
        showInJs.forEach(show => {
            const isSoldOut = show.sold_out ? show.sold_out : false;
            const isHidden = show.is_hidden ? show.is_hidden : false;
            if (!isSoldOut && !isHidden && show.items_for_sale) {
                show.items_for_sale.forEach(itemGroup => {
                    const isGroupAvailable = itemGroup.is_available;
                    if (isGroupAvailable && itemGroup.items) {
                        itemGroup.items.forEach(item => {
                            const availability_date = item.availability_date;
                            const itemAvailableForPurchse = item.quantity_available_for_purchase || 0 > 0;
                            let isAfter = false;
                            if (availability_date) {
                                const itemAvailableDate = new Date(availability_date);
                                const curr = new Date();
                                isAfter = itemAvailableDate > curr;
                            }
                            if (!item.is_hidden && item.item_state === "available" && isAfter && itemAvailableForPurchse) {
                                isItemAvailable = true;
                            }
                        });
                    }
                });
            }
        });
    }
    // otherwise return unavailable is no item is available
    return isItemAvailable ? eventData.get("event_state") : "unavailable";
};
/**
 * pluralize nount by count
 * @param {number} count
 * @param {string} noun
 */
export const pluralize = (count = 0, noun) => {
    if (count === 1)
        return `${count} ${noun}`;
    if (count > 1)
        return `${count} ${noun}s`;
    return null;
};
/**
 * make query string from params
 * @param {object} params
 * @return string
 */
export const makeQueryParams = params => {
    let e = encodeURIComponent;
    return Object.keys(params)
        .map(k => e(k) + "=" + e(params[k]))
        .join("&");
};
export const FIREFLIES_CITIES = ["mumbai", "pune"];
export const states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli ",
    "Daman and Diu ",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry ",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal"
];
export const webBlacklistTagId = "5836dfe53a3e6042078e2bc6";
export const paytmBlacklistTagId = "5cda6cae805a281efa09d7c0";
export const ELPSorters = List([
    Map({
        key: "popularity_score",
        label: "Popularity",
        type: "desc",
        value: "popularity"
    }),
    Map({
        key: "min_price",
        label: "Price",
        type: "asc",
        value: "price"
    }),
    Map({
        key: "min_show_start_time",
        label: "Date",
        type: "asc",
        value: "date"
    })
]);
export const DEFAULT_ELP_SORTER_VALUE = ELPSorters.getIn([0, "value"]);
// timestamps are added for tracking images in the EventAdBanner component
export const EventAdBannerConfig = {
    default: {
        campaignName: "District migration",
        desktopHref: "https://link.district.in/DSTRKT/insideredp",
        mobileHref: "https://link.district.in/DSTRKT/insideredp",
        desktopImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1733932541/usvywaxmqjktbifp3ndc.png",
        mobileImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1733932541/usvywaxmqjktbifp3ndc.png"
    },
    customEventIds: ["674823558b694060ad2c993b", "6748220f0f84dea1522e0db7"],
    //Hide Ad Banner tag for staging and prod
    hideForTagIds: ["6410a3b8681d5a0a539c2453", "6410a492e59709000831e7a9"],
    hideForEventIds: [
        "6402e538d8638500088fde5c",
        "64081c8ed46572000af15db3",
        "63f45d0337ec2100073ea8b3",
        "63f45e8a9b5fb30008fe754f",
        "64077ea055edfd0009687678",
        "63f45a78b9479e0008d14be9",
        "64037bd873d3a800096ef422",
        "6401d7ce87fc13000864537d",
        "64064836d0a8a200089e9c4f",
        "64064abda432f60008483bc2",
        "6405a588433b830008da47ab",
        "63fef83e1da7d60008b08c79",
        "63faf16c494f3c00080f3bfc",
        "63fd9654ab108c0008bd9e96",
        "63f3513132492000088ad850",
        "63f335df5106dd00085251cf",
        "63ae8e6d70a85b0008f6dd20",
        "63ef5cd1165bd700088e6b3f",
        "63e4f609071c0400086789a3",
        "63eb4d65a1b6ff00080971d4",
        "63eb3b63e97ef60008c11bc0",
        "639318efd0aa830008940580",
        "63e0fafdefb38100080d45fb",
        "63be9995b6bc8e0009c5314e",
        "63de76eec49b7d00096742a0",
        "63d741e3d2a81200089c5600",
        "63dc9d8651708f00080b222e",
        "63d8ed436e13460008246ac3",
        "63be9a57e63ff7000807f718",
        "63be65be8add300008da7ca3",
        "63b6f80d24b89b000ccac2a9",
        "63b80dc8f722750008712b6c",
        "63b7b7e5640ac8000851c551",
        "63b4452231df3d0008802c8b",
        "63a4194d182cfb00087da3d6",
        "63a55b4279b84c000874ed36",
        "635e8bf75ed47d0008f10b7d",
        "63873869b685f1000b46bcf5",
        "63970597811697000814a7eb",
        "639561b191823600081575b1",
        "638ca8a608af8c0008c5558d",
        "6386653415e67a000ad57b45",
        "638f62a52921a8000923761f",
        "6389cac86f223900096fea10",
        "63886793d885210009a9f54d",
        "6373951294adc70008ffb8a6",
        "638592677d112700086222a4",
        "637f6cce8a41b80008baab5f",
        "637f6769d7740e000870be45",
        "637f7c3766a6fb00085b94c6",
        "637f822b121eab0008e8682b",
        "637f97e3f515790008767810",
        "637fa236121eab0008e96567",
        "637a201007aa1c0008211af1",
        "637fc421bb46aa000849fd7e",
        "637fc5d2df612100081259a8",
        "637bb636d41aa8000839eb14",
        "637dd572c328250008f583c4",
        "6378b9f4702d01000865dec2",
        "637b34efccec920008076693",
        "637b2bf95a2e33000878b5ca",
        "637b2cd0fcea400008ae0ce2",
        "637b33d2b3780400095e0ce6",
        "6378ba1b97564b0008e6b551",
        "637a11fd07197e00087e036f",
        "637a14bccd3f4c0008220108",
        "637a1bfab3780400095bf330",
        "637a201007aa1c0008211af1",
        "63749ee0e201250008e348de",
        "636e28de75730f0008d5db60",
        "635a14cf50466b00081403ea",
        "636100279a779d00089496ad",
        "636d28543d1fdc0008f9ef83",
        "636ca9045632390008eafc12",
        "636a6a6beba8a300096adca3",
        "633fab7544d3dc0009764156",
        "63652092b90b000009165a11",
        "634fb526f89d3200089bc6c0",
        "634bd98b8eb1fa0008ff8b18",
        "63368c1b58b4680008f9fe47",
        "62f623ed68b4bb000872556b",
        "6340263fdefaf70008b82d19",
        "6339bc4107866600086a965a",
        "63218c32be5b54000884403c",
        "62fe32c9dfef6a000869ee59",
        "63470cd84a2fde0008b64dfc",
        "633d2d3aece4a60009835523",
        "6332e89395ce9a0008412a61",
        "63164d57dba52a0008350445",
        "63164ab083242c0008fac145",
        "63297b4918f5540009510f15",
        "6331613c8a52920009100fcd",
        "6333e51f58b4680008f333a0",
        "6333e453fadd9c000812e936",
        "6333e4b858b4680008f32efe",
        "632b1295ab8138000847c906",
        "6326d62ac9ccf30007d58112",
        "632436762b5acb00092a95a6",
        "6324445d0c918c000825b1ee",
        "632435e36eafef0008f0dc56",
        "6300d31376b7240008cf2ba1",
        "62ac6ae99ffb1f0008cb85de",
        "62a831a1d888570008ce4855",
        "62a6fdb423f6bf00087294f2",
        "62a024252b151100084e07c6",
        "626faa299f827900084fb2fb",
        "626fab2a45ecdc000822fbd4",
        "627e468ede17810008ebd76b",
        "626faaddad066500088fdfcc",
        "626faa839f827900084fb41f",
        "628783e030dbb7000887a621",
        "62568457d651630008e625ce",
        "624992e406a84600089dbbfd",
        "62430028c00e5a000848ac47",
        "624303d9bc7ce400081704d3",
        "6243051ed8461b0008993aa2",
        "6243074ba9a43a0008dffd58",
        "623c17ca53b2e200080a8f86",
        "622dec28f84f310008667159",
        "623898198ee87700082be6b1",
        "622ee95bf5cc450008f7b49b",
        "6226f69871a7bc0008d63b39",
        "6226f5d94d4d1a00080f9328",
        "621b6b7fa65c7200089d78cb",
        "6238347ddbe1f20008229fc1",
        "61b33658bd77170008c94328",
        "61b2035e1c78d500082fa44f",
        "618cf3ecabafa50008b07d05",
        "623066215806d70009e147da",
        "61c1ba3593f4d10008a956c2",
        "61b47fd4bd9103000875338a",
        "61b4395bfecdb500082e98ea",
        "6229a7acf42ded00081e2e98",
        "62285f603ff9b00008a1d575",
        "6211c7a888e64400080217eb",
        "60604781c16c0000084fb6e1",
        "6205ea35a1cf830008b34413",
        "6204dd37f22b250008874167",
        "6204d78f57acee0008401554",
        "6204e0aa172a8600081b3f31",
        "6205f602a1cf830008b34c98",
        "62052af67bca1800081a85dd",
        "620529f4172a8600081b5eb6",
        "6204efd837cc9e000821fc9e",
        "6204e6737642720008a736ae",
        "6205ed41266bcc00087441b3",
        "620602bd57acee0008406cc1",
        "61e66fcec38e7a0008527fee",
        "61bd14da5837860008476839",
        "61b32449eac37a00085ea602",
        "61a75d3f13caf1000805f039",
        "61a7be74ea6e370008bceafb",
        "619e622fc6670b000848c2b6",
        "619dbd8b1cf9f100084e5b4d",
        "617bc6789fcc410008c30383",
        "610b79ae57cd79000899d7fd",
        "6114a153ae91d90008db999f",
        "611ba2c1953fa70009fe2fb8",
        "612e1f3fa3760f00081ee08c",
        "615ab42bf71bfc0008b0b3e4",
        "617a6d3c23636100085cadff",
        "618a09e1e7015d0008cd00d3",
        "618c13f9aa3ff10008f1d435",
        "618cf3ecabafa50008b07d05",
        "618f67bde45363000806c5be",
        "618f6c8ef399b7000918deaf",
        "618f711fda8eed0008cefa83",
        "618f96ccb0315f000848737e",
        "617a6d3c23636100085cadff",
        "6190c22fc7b4500008c40fc7",
        "617fcdf6b800d400087b8e93",
        "618650276444fe0008dfae80",
        "61a35c7d63182700082818ef",
        "61a07aa362558e0008634c46",
        "61a079fd06fa900008a9c81f",
        "619f5529fd93da0008a7e577",
        "618e717424a84d0008083008",
        "620fb4a6ca6b98000872e4a2",
        "6215c277c4c83e000833265b",
        "6319fabdbd409c0009c6dfbf",
        "631b1e8d0649720008678c44",
        "632a8b6a956be10008334f45",
        "6333fb5a4a1cc400088d49eb",
        "633ad5b81198290008ca9e53",
        "63481d597e7492000801ac31",
        "634e520772da9c000851eab8",
        "63368c1b58b4680008f9fe47",
        "636352af51a40500084608c8",
        "62f4c815bcaec70008eec75a",
        "6374d110f925d1000802f578",
        "638dd1dd289f44000867aedc",
        "638ed38c567bf000090e1ce2",
        "638ed30bf40d3c00095bba45",
        "638dd9d03c6cd70008aca4f3",
        "639c7fd306afde00086b0d3f",
        "63a2c493059345000811e91a",
        "63a4398b098d4f0009148b60",
        "63bc2776ce1ea90008dd6884",
        "63bc293cf1fff1000866c693",
        "63bc25650aaea80008502fe3",
        "63c165b2f4705800091162cd",
        "63eb4433d2d2bd0008c9ce49",
        "63ea4658ccb6a6000842e65e",
        "63e394e689d2ca000a6a7109",
        "63feea7b86ebec0008040ec4",
        "63ff4d78f7a1550009b9b71c",
        "6402ea0481b601000837f0df"
    ],
    campaignName: "sauce-2023-edp-banner",
    desktopImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1734074457/wyiuucgzjbmztqipbljo.png",
    mobileImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1734074457/wyiuucgzjbmztqipbljo.png",
    desktopTrackingImage: null,
    mobileTrackingImage: null,
    desktopHref: "https://www.tatadigital.com/v2/finance/creditcard/pdp/cvp-district?utm_source=Partnerships_external&utm_medium=District&utm_campaign=AJS",
    mobileHref: "https://www.tatadigital.com/v2/finance/creditcard/pdp/cvp-district?utm_source=Partnerships_external&utm_medium=District&utm_campaign=AJS",
    shouldShowVideoModal: false,
    videoUrl: "https://www.youtube.com/embed/j8aC6ZUpghY"
};
// Config to skip "Invite your friends" section on EDP
export const ShareButtonsConig = {
    skipEventIds: [
        "63eb4d65a1b6ff00080971d4",
        "63eb3b63e97ef60008c11bc0",
        "63bc2776ce1ea90008dd6884",
        "63b80dc8f722750008712b6c",
        "605459e8b22c9f00087876b5",
        "6058b84382ac790008aced69",
        "60b4be4ff110130008c8ec5e",
        "60b4e54beebcfd000806b3cf",
        "619c962cb5df8a0008021243",
        "632436762b5acb00092a95a6",
        "6324445d0c918c000825b1ee",
        "64eaf8f67f87b40008916ef8",
        "64d32cb6a86c5400087250ea",
        "64d335ff7cc4a0000875542d",
        "65155df864ef780008098934",
        "65520d062c50be0009ee43b1",
        "658291fa625cf30008ca0f73",
        "6589afa7cef4b0000885790f",
        "6589b2613d2d82000870dbfe",
        "6582863bc98be60008de7685" // Student Concession Ticket | IDFC FIRST Bank T20I Trophy, 2nd T20I India vs Afghanistan
    ]
};
// Config to skip Prerequisities on EDP
export const PrerequisitiesConfig = {
    skipEventIds: [
        "63eb4d65a1b6ff00080971d4",
        "63eb3b63e97ef60008c11bc0",
        "63bc2776ce1ea90008dd6884",
        "63b80dc8f722750008712b6c",
        "605459e8b22c9f00087876b5",
        "6058b84382ac790008aced69",
        "60b4be4ff110130008c8ec5e",
        "60b4e54beebcfd000806b3cf",
        "62ba8646ba1fc900089c536e",
        "632436762b5acb00092a95a6",
        "6324445d0c918c000825b1ee",
        "63be9995b6bc8e0009c5314e",
        "63c3e6fb2615a10008ab7f0c",
        "63ec98fbac7bda000836bbbe",
        "63ec9c6407dafc0008967509",
        "63eca508cce4e40008d008a4",
        "63eca4984ec816000870ac6a",
        "63eca56e7722490008252b7e",
        "63eca5db8288a30008761eca",
        "64eaf8f67f87b40008916ef8",
        "64d32cb6a86c5400087250ea",
        "64d335ff7cc4a0000875542d",
        "65155df864ef780008098934",
        "65520d062c50be0009ee43b1",
        "658291fa625cf30008ca0f73",
        "6589afa7cef4b0000885790f",
        "6589b2613d2d82000870dbfe",
        "6582863bc98be60008de7685" // Student Concession Ticket | IDFC FIRST Bank T20I Trophy, 2nd T20I India vs Afghanistan
    ],
    skipBrandIds: ["622b343cdf0cdc0008b77a9b"],
    showEventIds: [
        "6512758067d0d200087885c3" // BCI Abundance Festival, 2023
    ]
};
export const openBrowserBuyFlowEventIds = ["637400326ba6e7000801115b", "63c3e6fb2615a10008ab7f0c"];
// Config to skip the wallet icon + price text on EDP
export const RsvpButtonConfig = {
    skipEventIds: [
        "62285f603ff9b00008a1d575",
        "60521d313b3cda00086b0418",
        "608c0bb215ec170008238b25",
        "608c0e8ead203700086d162b",
        "608be33c2ba2010008b44d4d",
        "608c16dccf50520008f0da6d",
        "608d8ff15a5556000a07a67d",
        "608d9112b739a70008d721dd",
        "608d91e428cc5e0008380480",
        "608d92d59db558000867e338",
        "608d93e7b22773000801fe0b",
        "608e48aeb634ee000853d711",
        "608e4e16b22a3e0008f9e547",
        "608ed7434be38300082ed056",
        "608f80bffa989e00089d58b2",
        "608f80c117628c00086ef1d8",
        "608f80c48745e70008bd696c",
        "608f9e19a4099800088cc75d",
        "608f9e2808d4590008901674",
        "608f9e409512100008e40f27",
        "608fe4a925dade000834fd91",
        "619c962cb5df8a0008021243",
        "61b1ded088c75f0008ba0211",
        "62a831a1d888570008ce4855",
        "62a6fdb423f6bf00087294f2"
    ]
};
// Config to block event purchase on ios
export const iOSEventPurchaseConfig = {
    skipEventIds: ["61949c6cde893b0008bddb26", "6309abd2d0207000080a9b03"]
};
// Config to skip venue text on EDP
export const venueConfig = {
    skipEventIds: ["61b1ded088c75f0008ba0211"]
};
// Config to skip report event section on EDP
export const reportEventConfig = {
    skipEventIds: ["5f0c233c370f1e00087a53a4"]
};
// Config to skip related event section on EDP
export const relatedEventConfig = {
    skipEventIds: []
};
// timestamps are added for tracking images in the PaymentSuccessAdBanner component
/*
 * Key to be added for iOs on PaymentSuccessAdBannerConfig :
 * hideForIOS : true , if we don't want to show banner on iOs devices
 * showForIOS : true , if we wan tto to show a different banenr for iOs device, create another object named PaymentSuccessAdBannerConfigIOS with same format
 * * don't make both true
 * * No need to add above keys on PaymentSuccessAdBannerConfigIOS, adding keys (if required) on original config object is sufficient.
 * * Don't add any key if not required
 */
export const PaymentSuccessAdBannerConfig = {
    campaignName: "District",
    desktopImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1733931887/d3j0oj4z80rzbncdpmij.png",
    mobileImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1733931887/tsxhwcbgjwkmnarjgjnc.png",
    desktopTrackingImage: null,
    mobileTrackingImage: null,
    desktopHref: "https://link.district.in/DSTRKT/insiderbookingconfirmation",
    mobileHref: "https://link.district.in/DSTRKT/insiderbookingconfirmation",
    skipEventIds: [
        "66028eed80e39b0008d4aa15",
        "66028fbf0df0c6000898e55e",
        "66028e446bd9e40008b9994a",
        "65d9f29d5fb7820008132604",
        "65de16acac2d5a0008627e21",
        "65de178bcfe1d3000852faac",
        "65e026c87efb9400084a4e61",
        "65c4a10a607cf2000899fe92",
        "6457a2ca617b8600087b6a62",
        "6457be0e99e0a60008ab5979",
        "62a831a1d888570008ce4855",
        "62a6fdb423f6bf00087294f2",
        "632a8b6a956be10008334f45",
        "63f379af0f97710008323704",
        "63f37ab99b90420009f838ae",
        "63f37b56e277960008648d85",
        "63f37bd9bc69a20008a89cc0",
        "63f37c555c43900008afeb10",
        "63f37cff4cb2880008216b69",
        "63f45d0337ec2100073ea8b3",
        "63f45e8a9b5fb30008fe754f",
        "63f45fa8193cce000896c554",
        "63f464413dfd430008e70ea2",
        "63f46851e36c29000927408d",
        "63f4697a3f7ade0008199da6",
        "63f47fbf08f96e00085690d6",
        "63f48063e7dfe8000840315c",
        "63f4811ce7dfe8000840363c",
        "63f481f88b2a7a00082541cf",
        "63f482c3f3ac6b000803339b",
        "63f483f7cb2c9a0008213b32",
        "6402e7edd8638500088ff7f6",
        "6402eaf92cd0fe00098c189c",
        "6402ec14b084d600089aff63",
        "6402efafd825bd0009c87e3e",
        "6402f16817aba3000845fc3f",
        "6402f4877cd6a30008bc2e9c",
        "64064abda432f60008483bc2",
        "64077ea055edfd0009687678",
        "640783717af4ba0008d50c11",
        "6407844ab4439b0008fd9796",
        "640785106efcc8000821abe2",
        "640785ac5b998f00090c05dd",
        "64107ac01b049100083763f4",
        "64107c1eced6020008d29fce",
        "64107cc06e24620009ee4ede",
        "64107d54f5f3b300089d0e71",
        "64107dc5c8514a0008c89272",
        "64107e2cd9fa52000888199d",
        "641c48a89e77a6000819bb37",
        "64575910eb01ec0008c20c61",
        "6458e46fdd7bad0008ed92c0",
        "65dec585a195e00008d60ac0",
        "65deae8e52a06d0008a72e57",
        "65deb046ac2d5a000864f796",
        "65dcd1b63d62f60008cedcbb",
        "65dcd3444dd14c000860dfb0",
        "65dcd455ecc13a00084b4ebf",
        "65dcd51b193546000836f064",
        "65dcd5ad69b008000854bb42",
        "65dcd637d8097a00080d46da",
        "65dcd6aed792ba0008b06aad",
        "65ded03686193a000885681f",
        "65ded0bf74d0950008e207b2",
        "66028bc40df0c60008986848"
    ]
};
export const PaymentSuccessAdBannerConfigIOS = {};
// Custom Thankyou Banner for Gujrat
export const customPaymentSuccessBannerGujrat = {
    campaignName: "custom_thank_you_banner_gujrat",
    desktopImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1710147755/zdg9ecrdn296av2vbpal.png",
    mobileImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1710147890/zrho0k04ebhb5akvz9lq.png",
    desktopTrackingImage: null,
    mobileTrackingImage: null,
    desktopHref: "https://www.gujarattitansipl.com/shop?utm_source=paytm&utm_medium=ticket_tybanner&utm_campaign=gt",
    mobileHref: "https://www.gujarattitansipl.com/shop?utm_source=paytm&utm_medium=ticket_tybanner&utm_campaign=gt",
    eventIds: [
        "66028eed80e39b0008d4aa15",
        "66028fbf0df0c6000898e55e",
        "66028e446bd9e40008b9994a",
        "624bfc896560780008a6a903",
        "62bc25ba2d5fa02e41c2fafb",
        "639b909936e6fa0008ed111e",
        "64575910eb01ec0008c20c61",
        "6458e46fdd7bad0008ed92c0",
        "65d9f29d5fb7820008132604",
        "65de16acac2d5a0008627e21",
        "65de178bcfe1d3000852faac",
        "66028bc40df0c60008986848"
    ]
};
// Custom Thankyou Banner for Punjab
export const customPaymentSuccessBannerPunjab = {
    campaignName: "custom_thank_you_banner_punjab",
    desktopImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1710212755/gcqj4o3dpgtidqbgso0x.png",
    mobileImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1710212755/f5de44l956qopku70dzx.png",
    desktopTrackingImage: null,
    mobileTrackingImage: null,
    desktopHref: "https://www.punjabkingsipl.in/shop?utm_source=paytm&utm_medium=ticket_tybanner&utm_campaign=pbks",
    mobileHref: "https://www.punjabkingsipl.in/shop?utm_source=paytm&utm_medium=ticket_tybanner&utm_campaign=pbks",
    eventIds: ["65dec585a195e00008d60ac0"]
};
export const EventPromoCodeBannerConfig = {
    mobileImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1568801504/r1rrcv6254zplfnbsvcz.jpg",
    couponCode: "CRIC35"
};
export const CheckoutAdBannerConfig = {
    mobileHref: "https://link.insider.in/appyhours",
    mobileImageUrl: "https://media.insider.in/image/upload/c_crop,g_custom/v1557317413/jvol49yse7pj8hg6hy0r.png"
};
export const CategoryIdsToSkipTagAndInfo = {
    skipCategoryIds: ["5bb59edafc5a50001874beb3", "6092376af82fb600087c333f"]
};
export const NUM_CATEGORIES_TO_DISPLAY_ON_HOME_PAGE = 8;
export const NUM_RECENTLY_TO_DISPLAY_ON_HOME_PAGE = 6;
export const HOME_PAGE_BANNER_GROUP_ID = "5c1224923ca1ed0007dc68db";
export const IMAGE_URLS = {
    HELMET: "https://media.insider.in/image/upload/c_crop,g_custom/v1564574110/z7ccf1k3ylg0t2glqrfm.png"
};
export const PAYTM_INSIDER_LOGO_URL = "https://res.cloudinary.com/dwzmsvp7f/image/upload/w_192/Insider_Logo_Colour_rrag9p.png";
export const PAYTM_INSIDER_INVERTED_LOGO_URL = "https://res.cloudinary.com/dwzmsvp7f/image/upload/w_320/Insider_Logo_Inverted_xbyvil.png";
export const PAYTM_API_URL = typeof window !== "undefined" && window.env === "live"
    ? "https://apiproxy.paytm.com"
    : "http://staging.paytmpropxy.insider.in";
export const PAYTM_PROMO_CODE_URL = typeof window !== "undefined" && window.env === "live" ? "https://paytm.com" : "https://staging.paytmmall.com";
export const HOME_BANNER_CAROUSEL_AD_CONFIGS = {
    BannerID: "5e6f335a0e2e1d000811630d",
    TrackingImageUrl: "https://ad.doubleclick.net/ddm/trackimp/N743069.3734974PAYTMINSIDER/B23874412.270148365;dc_trk_aid=464695345;dc_trk_cid=129961549;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"
};
export const GROUP_BANNER_CAROUSEL_AD_CONFIGS = {
    BannerID: "5e6f2089d70f220008b3d0b2",
    TrackingImageUrl: "https://ad.doubleclick.net/ddm/trackimp/N743069.3734974PAYTMINSIDER/B23874412.270148365;dc_trk_aid=464695345;dc_trk_cid=129961549;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"
};
export const PROMO_BANNER_DATA = {
    "5e3140cd73b0d4000877e7f1": {
        articleLink: "https://insider.in/the-circuit-comedy-festival-mumbai/article",
        imageLink: "http://bit.ly/386JJRJ"
    },
    "5e31410273b0d4000877e7fb": {
        articleLink: "https://insider.in/the-circuit-comedy-festival-delhi?utm_source=InsiderWebsite&utm_medium=Email&utm_campaign=Grofers-North-Delhi-IB&utm_term=GrofersDatabase&utm_content=February14",
        imageLink: "http://bit.ly/2vVzGkm"
    },
    "5e3140e5f862480008a8c89b": {
        articleLink: "https://insider.in/the-circuit-comedy-festival-bangalore/article",
        imageLink: "http://bit.ly/2GWdw3A"
    }
};
export const EVENT_LEVEL_TRACKING_PIXELS = [
    {
        eventId: "5f106ba729711200086adc45",
        trackingImageUrl: "//cdn-akamai.mookie1.com/LB/LightningBolt.js",
        type: "script"
    }
];
export const NUM_CATEGORY_CAROUSEL_TO_DISPLAY_ON_HOME_PAGE = 5;
export const NUM_CATEGORY_CARDS_TO_DISPLAY_ON_HOME_PAGE = 10;
export const DEFAULT_COUNTRY_CODE = "+91";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=in.insider.consumer&hl=en";
export const APP_STORE_URL = "https://itunes.apple.com/app/id1179683119?action=write-review";
export const ONLINE_CITY_TITLE = "Online Events - (Experience Digital & Virtual Events on insider.in)";
export const TIME_FILTER_REGEX = /\b-today|\b-tomorrow|\b-weekend|/g;
export const DIGITAL_EVENTS_ICON = "https://media.insider.in/image/upload/c_crop,g_custom/v1593588154/lrfuoqcir5df3ntuabae.png";
export const FOOTER_BANNER_IMAGE_DEFAULT = "https://media.insider.in/image/upload/c_crop,g_custom/v1595501695/xednuscwqg6jyenkqmrc.jpg";
export const FOOTER_BANNER_IMAGE_MOBILE = "https://media.insider.in/image/upload/c_crop,g_custom/v1594357266/nj77hi20djbcewtvwfrw.jpg";
export const FOOTER_BANNER_IMAGE_TABLET = "https://media.insider.in/image/upload/c_crop,g_custom/v1594357334/suxglsu9fgx9nkxjxdob.jpg";
export const FOOTER_BANNER_IMAGE_PC = "https://media.insider.in/image/upload/c_crop,g_custom/v1595501695/xednuscwqg6jyenkqmrc.jpg";
export const FOOTER_BANNER_IMAGE_HD = "https://media.insider.in/image/upload/c_crop,g_custom/v1595501695/xednuscwqg6jyenkqmrc.jpg";
export const SocialTypes = {
    Facebook: "fb",
    Instagram: "instagram",
    Twitter: "twitter"
};
export const SOCIAL_IMAGE_CONFIG = {
    [SocialTypes.Facebook]: {
        href: "https://facebook.com/Insider.in.official",
        imgSrc: "https://media.insider.in/image/upload/w_64/wpcazok1bgq6b3j8tahh.png"
    },
    [SocialTypes.Twitter]: {
        href: "https://x.com/lifeindistrict",
        imgSrc: "https://media.insider.in/image/upload/w_64/tfc4w4qegxy69uxqiz2d.png"
    },
    [SocialTypes.Instagram]: {
        href: "https://www.instagram.com/insider.in",
        imgSrc: "https://media.insider.in/image/upload/w_64/curdqlooy118d6oimrnw.png"
    }
};
export const getLiveRedirectNotificationMessage = email => `You are logged in with ${email}.
	This account does not have access to this show.
	Please make sure you are logged in with the correct account to watch this event.`;
export const PAYTM_HOME_DEEP_LINK = "paytmmp://homepage_primary";
export const HomePageGroupCarouselConstants = {
    enabled: true,
    groupName: "Holi 2022",
    carouselTitle: "Holi RangOver 2022",
    carouselSubTitle: city => `Parties, getaways & more. All Holi Tolis this way please`,
    hasGroupIcon: true,
    groupIconSrc: "/assets/img/holi-icon.svg"
};
export const UNVERIFIED_API_KEY_ERROR_CODE = "A-01";
export const EMAIL_REGEX = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const GLOBAL_TAG = "5e9eacd93dc0550988a466dd";
export const UPI_APPS = [
    {
        name: "Paytm",
        icon: "/assets/images/intent-images/paytm.png",
        value: "Paytm"
    },
    {
        name: "GPay",
        icon: "/assets/images/intent-images/gpay.png",
        value: "GPAY"
    }
    //uncomment this when PhonePe is fixed from Paytm PG's end
    // {
    // 	name: "PhonePe",
    // 	icon: "/assets/images/intent-images/phonepe.png",
    // 	value: "PhonePe"
    // }
];
export const blueDartTrackingUrl = awb => {
    return `https://api.bluedart.com/trackdartresultthirdparty?trackFor=0&trackNo=${awb}`;
};
// NOTE: Getstream is currently not used, removing the keys for security reasons
// When/If needed, check a more secure way to set this up
// const GetStreamProdConfig = {
// 	GETSTREAM_API_KEY: "",
// 	GETSTREAM_APP_ID: ""
// };
// const GetStreamDevConfig = {
// 	GETSTREAM_API_KEY: "",
// 	GETSTREAM_APP_ID: ""
// };
// export const GetstreamConfig =
// 	typeof window !== "undefined" && window.env === "live" ? GetStreamProdConfig : GetStreamDevConfig;
export const JSElementsScriptUrl = () => {
    return typeof window !== "undefined" && window.env === "live"
        ? "https://secure.paytmpayments.com/merchantpgpui/checkoutjs/merchants/WASTel83086940698978.js"
        : "https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/WSEMPL97374941036172.js";
};
export const paymentsMID = () => {
    return typeof window !== "undefined" && window.env === "live" ? "WASTel83086940698978" : "WSEMPL97374941036172";
};
export const paymentsHost = () => {
    return typeof window !== "undefined" && window.env === "live"
        ? "https://payment.insider.in"
        : "https://payment-staging.insider.in";
};
export const GoogleAuthClientId = "334845953761-37s2pgp1nj8rpme7uo97jfbas49t1928.apps.googleusercontent.com";
// Ticket Detail constants
export const skipQRCodeEventIds = ["6165b5a091c6da0008cd0204", "61b1ded088c75f0008ba0211", "627e546803a08a00082a1d59"];
export const skipEventInstructionsEventIds = [
    "6165b5a091c6da0008cd0204",
    "61b1ded088c75f0008ba0211",
    "627e546803a08a00082a1d59"
];
export const skipPaymentDetailsEventIds = [
    "6165b5a091c6da0008cd0204",
    "61b1ded088c75f0008ba0211",
    "627e546803a08a00082a1d59"
];
// Checkout Constants
export const checkoutToShowRedirectEventIds = [
    "65155df864ef780008098934",
    "6353d61e42d4c700085e18a3",
    "62160ba70b32b9000843b2fd",
    "628f415b9b6f8400089e25d7",
    "62d929b3e99501000a92629b"
];
export const checkoutToShowRedirectBrandConfig = {
    brandIds: ["622b343cdf0cdc0008b77a9b"],
    brandRedirectMap: {
        "622b343cdf0cdc0008b77a9b": "https://summerfiesta.ncpamumbai.com/"
    }
};
export const fetchableModelsForTags = {
    article: "article",
    event: "event"
};
/**
 * Map older city name to their new counterparts
 * @param {String} currentCityName
 * @returns {String}
 */
export const updatedCityName = currentCityName => {
    switch (currentCityName) {
        case "bangalore":
            return "bengaluru";
        default:
            return currentCityName;
    }
};
export const CURRENCY_CODE = "INR";
/**
 * Create item params for GA4 events parameter
 * @param {List<ICartItem>} itemData
 */
export const createCartItemParam = itemData => {
    const itemParams = itemData.map(item => {
        return {
            item_id: item.get("id"),
            item_name: `${item.getIn(["parent", "parent_id", "name"])} - ${item.get("name")}`,
            currency: CURRENCY_CODE,
            price: item.get("price"),
            quantity: Number(item.get("count"))
        };
    });
    return itemParams;
};
/**
 * Adds GA4 events
 * @param {String} eventName
 * @param {Object} payload
 */
export const addGAEvent = (eventName, payload) => {
    window.gtag && gtag(GA_EVENT, eventName, payload);
};
export const minEMIAmount = 499;
export const FreshdeskLoginURL = `https://insider-551741634173780130.myfreshworks.com/login/auth/1681710983626?client_id=451980303908285122&redirect_uri=https%3A%2F%2Finsidersupport.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Dinsidersupport.freshdesk.com`;
export const deliveryTrackingCardTagId = typeof window !== "undefined" && window.env === "live" ? "63fe6095bbb362000858c26d" : "63fe5f8ef3bfd84ca12be95a";
export const IPLPaytmSignUpEventIds = [
    "639b909936e6fa0008ed111e",
    "63faf16c494f3c00080f3bfc",
    "63feea7b86ebec0008040ec4",
    "6401d7ce87fc13000864537d",
    "63fef83e1da7d60008b08c79",
    "63ff4d78f7a1550009b9b71c"
];
export const IPLMatchEventIds = [
    "641c48a89e77a6000819bb37",
    "62693a742158ef1812367472",
    "624bfc896560780008a6a903",
    "639b8f85f89fe90008c4829e",
    "639b909936e6fa0008ed111e",
    "63f45a78b9479e0008d14be9",
    "63f47e27ee9d85000848f870",
    "6402e538d8638500088fde5c",
    "64064836d0a8a200089e9c4f",
    "63f379af0f97710008323704",
    "6402e7edd8638500088ff7f6",
    "63f45d0337ec2100073ea8b3",
    "64077ea055edfd0009687678",
    "63f37a3e22be940008bb9d8b",
    "63f47fbf08f96e00085690d6",
    "6402eaf92cd0fe00098c189c",
    "63f45e8a9b5fb30008fe754f",
    "64064abda432f60008483bc2",
    "63f48063e7dfe8000840315c",
    "63f37ab99b90420009f838ae",
    "6402ec14b084d600089aff63",
    "63f45fa8193cce000896c554",
    "63f4811ce7dfe8000840363c",
    "63f37b56e277960008648d85",
    "6402efafd825bd0009c87e3e",
    "63f464413dfd430008e70ea2",
    "63f481f88b2a7a00082541cf",
    "6402f16817aba3000845fc3f",
    "63f37bd9bc69a20008a89cc0",
    "63f46851e36c29000927408d",
    "63f37c555c43900008afeb10",
    "63f4697a3f7ade0008199da6",
    "6402f4877cd6a30008bc2e9c",
    "63f482c3f3ac6b000803339b",
    "63f483f7cb2c9a0008213b32",
    "63f37cff4cb2880008216b69"
];
export const InsiderLogoImage = `https://media.insider.in/image/upload/c_crop,g_custom/v1564574110/z7ccf1k3ylg0t2glqrfm.png`;
export const LSGMatchEventIds = ["6402efafd825bd0009c87e3e", "6402f16817aba3000845fc3f", "6402f4877cd6a30008bc2e9c"];
export const isRupayEvent = ["62cd5fad87f3ad0008ab1b36"];
export const isHSBCEvent = ["639b909936e6fa0008ed111e"];
// export const newCheckoutFlowEventIds = [
// 	"64acf881d2470d7530a0b144", // Atul Staging test events
// 	"64c9f255db6b830898c84908",
// 	"64ccb231c207ff086d3de0ae",
// 	"64ccad8cc207ff086d3de038",
// 	"64de3f9d401dce6ab15ec4a6",
// 	"64eec092e04b4e0009ca83c4", // Atul Prod test event
// 	"64eec0d7e5162c0008098763", // Atul Prod test paid pickup event
// 	"650043e0586827000894623c", // Prod: Falguni Test Custom Checkout
// 	"64f59393cf401d0008cbfe2b" // Prod: Paid pickup add on item Falguni
// ];
// these category carousals will be pinned on top if they have more than 3 events
export const categoryCarouselsToPin = [
    "Durga Puja 2024",
    "Navratri 2024",
    "Music",
    "Comedy",
    "Theatre & Arts",
    "Workshops"
];
// ISL go page tags for custom empty state
export const ISLGoTags = [
    "indian-super-league-2024-25",
    "indian-super-league-2024-25-bengaluru-fc",
    "kbfc-isl-2024-25",
    "fc-goa-isl-2024-25",
    "odisha-fc-isl-2024-25",
    "mohammedan-sc-isl-2024-25"
];
// A mapping to redirect the user to a custom link post payment success
export const postPaymentRedirectionLinks = {
    //ComiCon 2024
    "66e6938f017d845e4cd1db1f": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-ccc",
        redirectTimer: 3000
    },
    "6707bbd8212f032414274867": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-ccc",
        redirectTimer: 3000
    },
    "67051994c44ec1c8c0278bdd": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-hcc",
        redirectTimer: 3000
    },
    "66c818dcd689fab6f65e9a50": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-hcc",
        redirectTimer: 3000
    },
    "66e6931e68e43a3b021c6cc1": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-bcc",
        redirectTimer: 3000
    },
    "66ff01fe1e7b62e5e4af8bb4": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-bcc",
        redirectTimer: 3000
    },
    "66d94b7baa0024f0289040c2": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-dcc",
        redirectTimer: 3000
    },
    "66f5a7c2e609c685af69f580": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-dcc",
        redirectTimer: 3000
    },
    "6710eb9438d49909bd7932a0": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-kcc",
        redirectTimer: 3000
    },
    "6710e9fa52165ac08748d8a0": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-kcc",
        redirectTimer: 3000
    },
    "675ab3ce187e186e3b1c4280": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-pcc",
        redirectTimer: 3000
    },
    "676460816b858c1c5eed3203": {
        redirectURL: "https://www.comicconindia.com/thank-you-pages/thank-you-acc",
        redirectTimer: 3000
    },
    // Prod: Monkey Market Festival | Mumbai
    "654b88d98a42aa00082c397c": {
        redirectURL: "https://www.monkeymarketfestival.com/thank-you",
        redirectTimer: 3000
    },
    // Prod: Test CF Invoice Event - OCL
    "639b8f85f89fe90008c4829e": {
        redirectURL: "https://echoesofearth.com/thank-you.php",
        redirectTimer: 3000
    },
    // Prod: Echoes of Earth, 2023
    "64f05f21004d890008b0c4c9": {
        redirectURL: "https://echoesofearth.com/thank-you.php",
        redirectTimer: 3000
    },
    // Prod: Spokenfest 2024
    "6530d13a40a30d0008619361": {
        redirectURL: "http://www.spokenfest.com/thankyou",
        redirectTimer: 1000
    },
    // Staging: Atul Test Navratri
    "64df51ed4fabd3c748dae260": {
        redirectURL: "https://google.com",
        redirectTimer: 5000
    },
    // Staging: Atul Test World Cup 2023
    "64acf881d2470d7530a0b144": {
        redirectURL: "https://github.com",
        redirectTimer: 2000
    },
    // Prod: Atul Test Live Event
    "6512c40b3eed290008e01414": {
        redirectURL: "https://github.com",
        redirectTimer: 2000
    },
    "66f272e81ff0f8e593178436": {
        redirectURL: "https://github.com",
        redirectTimer: 2000
    },
    //NH7 Weekender 2024 | Pune
    "671cc20ca17cdf17aef34832": {
        redirectURL: "https://nh7.in/thank-you-pune/",
        redirectTimer: 3000
    }
};
export const ACCESSIBLITY_TALKBACK_PHRASES = {
    BUTTON: "Double tap to activate"
};
export let PAYTM_AUTH_CONFIG = typeof window !== "undefined" && window.env === "live"
    ? {
        clientId: "paytm-insider-auth-production",
        authHeader: "cGF5dG0taW5zaWRlci1hdXRoLXByb2R1Y3Rpb246eDFIQ3hpUFRsQm9qdWlrbk9IOE5vZkxjZ2V2bnVQWUU="
    }
    : {
        clientId: "paytm-insider-auth-staging",
        authHeader: "cGF5dG0taW5zaWRlci1hdXRoLXN0YWdpbmc6NTYyb2t3UHd4ZEdiT2Q3SjE4ODNzUTR5MklsbDB2ZFg="
    };
export const SHOW_PAYMENTS = {
    STEPS: {
        COMPLETE: "complete",
        VERIFY_COMPLETED: "verifyCompleted",
        SECOND_VERIFY: "secondVerify"
    }
};
export const DEFERRED_CHECKOUT = {
    STEPS: {
        PAYMENT_COMPLETED: "payment_completed",
        PAYMENT_INTENT_PROCEED: "payment_intent_proceed",
        CHANGE_PAYMENT_METHOD: "change_payment_method",
        CHANGE_PROMOCODE_METHOD: "change_promocode_method",
        CHECKOUT: "checkout"
    }
};
export const SEATSIO = typeof window !== "undefined" && window.env === "live"
    ? {
        PUBLIC_WORKSPACE_KEY: "135e9fa6-95fe-41b0-8baf-f3ccca384036"
    }
    : {
        PUBLIC_WORKSPACE_KEY: "e470f329-c50f-4e6b-8739-f127fdb4a4fd"
    };
export const EVENT_GROUP_ID = "5804727dfdacc65c25706adf";
export const SPORTS_GROUP_ID = "59185d836f049f59072e691b";
export const SCREENING_CATEGORY_ID = "5718844ba7c87aa4bf028489";
export const ShowOtpOnTypeIssued = [
    "666186ee0a2e50e7b04428df",
    "65f30fb61e4be9f3fa452ac8",
    "65e21847ebd9be000846f2f1",
    "64acf881d2470d7530a0b144"
];
export const restrictFileTypeWhileUpload = [
    "64eec092e04b4e0009ca83c4",
    "66ba0031776c3286aa1209f1" // vadodara navratri fest
];
export const allowNewIframeRedirectMerchantId = [
    "65e44c125ab39300081f6a61",
    `66c99a4c2ffbaf6faad08df4`,
    `66cd7b9e63858aa4bd09c927`,
    `668e7d9837168cfbb435a07e`,
    `66de9df89ddaeec2b010b1ce`
];
export const allowedIframeOrigins = [`preprod.publish.insider.in`, `new.insider.in`, `2024.echoesofearth.com`];
export const hideDETicketForItemIDs = [
    "66f2d6eb319b6acb1a5f1a80",
    "66f2d3634904c6c19438580b",
    "66f2d2ad93b5980e096e6302",
    "66f2caa87c40a2328bd37bb4",
    "66f2c9dcfe635e43c1dd3281",
    "66f2c916fdfb528ae370d89f",
    "66f2c61edf9f3041dee58c94",
    "66f2c4353d68eeed8d5f294c"
];
